import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { providersTabs } from '../../../routes/purchases';

const PurchasesSideProviders = () => {
  const tabs = providersTabs();
  return <FingoPaper tabs={tabs} />;
};

export default PurchasesSideProviders;
